<template>
  <div style="height: 100%;">
    <img src="static/login/bg.jpg" width="100%" height="100%">
    <div id="login-warp">
      <div id="login-top">
        <img :src="$store.state.csr.linkLogoPic" />
        <h1>{{ $store.state.csr.name }}</h1>
      </div>
      <div id="login-left">
        <img src="static/login/pic1.jpg" width="100%" height="100%">
        <div id="erweima">
          <img src="static/e/webapp.png" width="100px">
          <p>安卓移动端，浏览器扫码下载</p>
        </div>
      </div>
      <div id="login-right">
        <h2>欢迎登录系统</h2>

          <Form ref="caritem" :model="loginMsg" :label-width="80">
            <Row :gutter="16">
              <Col span="24">
                <FormItem label="用户名" prop="username">
                  <Input v-model="loginMsg.username" placeholder="请输入"
                    ><template #append>
                      <Button @click="$refs.moreAcount.reach()"
                        >切换用户</Button
                      >
                    </template></Input
                  >
                </FormItem>
              </Col>
              <Col span="24">
                <FormItem label="密码" prop="password">
                  <Input
                    v-model="loginMsg.password"
                    placeholder="输入6位以上密码"
                    type="password"
                    password
                  ></Input>
                </FormItem>
              </Col>
            </Row>
          </Form>
          <Button
            :disabled="
              loginMsg.username.length == 0 || loginMsg.password.length < 6
            "
            id="loginBtn"
            long
            :loading="loading"
            @click="login"
          >
            <span v-if="!loading">立即登录</span>
            <span v-else>登录中...</span>
          </Button>
          <Checkbox
            v-model="storagePasspord"
            id="loginCheck"
            :disabled="
              loginMsg.username.length == 0 || loginMsg.password.length < 6
            "
            >记住用户名和密码</Checkbox
          >

      </div>
    </div>
    <moreAcount ref="moreAcount" @msg="reMsg"></moreAcount>
  </div>
</template>
<script>
var axios;
import moreAcount from "./moreAcount.vue";
import morePlat from "./morePlat.vue";
import erweima from "./erweima.vue";
export default {
  props: ['hidehangye'],
  components: { moreAcount, morePlat, erweima },
  data() {
    return {
      loading: false,
      hidehypt: false,
      loginMsg: {
        username: "",
        password: "",
      },
      storagePasspord: false,
      logObj: {},
    };
  },
  methods: {
    reachData(a) { },
    reMsg(v) {
      if (v) {
        this.loginMsg = v;
        this.storagePasspord = true;
      } else {
        this.loginMsg.username = "";
        this.loginMsg.password = "";
        this.storagePasspord = false;
      }
    },
    login() {
      if (
        this.loginMsg.username.length == 0 ||
        this.loginMsg.password.length == 0
      ) {
        this.$Message.error("用户名或密码不能为空");
        return;
      }
      this.loading = true;
      let params = {
        account: this.loginMsg.username,
        password: this.loginMsg.password,
        platformId: this.axios.plat,
        tokenType: 2,
      };
      this.axios({
        method: "post",
        url: this.axios.commonAuth + "/auth/login/password",
        data: params,
      }).then((res) => {
        console.log(res);
        this.loading = false;
        var myData = res.data;
        if (myData.code == 200) {
          var obj = {
            accessToken: myData.data.accessToken,
            platformId: params.platformId,
            identityId: myData.data.identityId,
            customerId: myData.data.customerId,
            identityType: myData.data.identityType,
          };
          sessionStorage.setItem(this.axios.plat, JSON.stringify(obj));
          if (this.storagePasspord) {
            this.$refs.moreAcount.save(this.loginMsg);
          } else {
            this.$refs.moreAcount.del(this.loginMsg.username);
          }
          this.$emit("goto");
        } else {
          this.$Message.error(myData.message);
        }
      });
    },
    //回车键起来
    keyupEnter() {
      var that = this;
      document.onkeydown = function (event) {
        var e = event || window.event || arguments.callee.caller.arguments[0];
        if (e && e.keyCode == 13) {
          that.login();
        }
      };
    },

    getUrlKey(name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || [, ""])[1].replace(/\+/g, "%20")
        ) || null
      );
    },
  },
  mounted() {
    this.keyupEnter();

    if (this.getUrlKey("t") == null) {
      this.hidehypt = false;
    } else {
      this.hidehypt = true;
    }
  },
  destroyed() {
    document.onkeydown = function (event) {
      var e = event || window.event || arguments.callee.caller.arguments[0];
      if (e && e.keyCode == 13) {
        return;
      }
    };
  },
};
</script>
<style>
#login-warp {
  width: 1000px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -500px;
  margin-top: -220px;
  display: flex;
  flex-wrap: wrap;
}

#login-warp #login-top {
  width: 1000px;
  height: 70px;
  display: flex;
}
#login-warp #login-top img {
  height: 50px;
}
#login-warp #login-top h1 { 
  color: #fff;
  font-size: 36px;
  margin-left: 20px;
  margin-top: 10px;
}
#login-warp #login-left {
  width: 650px;
  height: 340px;
  position: relative;
}

#login-warp #login-left #erweima {
  width: 100px;
  color: #fff;
  position: absolute;
  bottom: 20px;
  left: 20px;
}

#login-warp #login-right {
  width: 350px;
  height: 340px;
  background: white;
  padding: 20px;
}
#login-warp #login-right h2 {
  text-align: center;
  margin-bottom: 20px;
  margin-top: 20px;
}
#loginBtn {
  background: var(--loginColor);
  color: #fff;
  margin-top: 30px;
  margin-bottom: 10px;
}
#loginCheck .ivu-checkbox-checked .ivu-checkbox-inner {
  border-color: var(--loginColor);
  background-color: var(--loginColor);
}
</style>


// WEBPACK FOOTER //
// ../common/src/components/sys/login1.vue